module.exports = __webpack_public_path__ + "static/images/mb-6.d73454b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flat/mobile/mb-6.png
// module id = 351
// module chunks = 1